import { useState, useEffect } from 'react';
import { useUser } from '../../context/UserContext';

export const useCountryCodeCheck = () => {
  const { userData } = useUser();
  const [needsCountryCode, setNeedsCountryCode] = useState(false);

  useEffect(() => {
    if (userData) {
      // Verificar si el usuario no tiene código de país o está vacío
      const needsUpdate = !userData.countryCode || 
                         userData.countryCode === "" || 
                         userData.countryCode === null || 
                         userData.countryCode === undefined||
                         !userData.phoneNumber ||
                         userData.phoneNumber === null ||
                         userData.phoneNumber === "" ||
                         userData.phoneNumber === undefined;
      
      setNeedsCountryCode(needsUpdate);
    } else {
      setNeedsCountryCode(false);
    }
  }, [userData]);

  return needsCountryCode;
};

export default useCountryCodeCheck;
